module.exports = __webpack_public_path__ + "img/planta_16.2fb9179d.png";